import React from 'react';
import { Flex } from '../../common/Flex';
import NetworkMonitoringHeader from './NetworkMonitoringHeader';
import { ConfiguredAirspace } from 'app/model/SOL49';
import { SectorFlows } from './fmp/SectorFlows';
import { NetworkMonitoring, NetworkMonitoringProps, NetworkMonitoringState } from './NetworkMonitoring';
import { Banner } from '../global/Banner';
import { CountType, TimePeriod } from '../../../model/CORE';
import AppContext from 'app/common/context/AppContext';

interface FmpNetworkMonitoringProps extends NetworkMonitoringProps {
    configuredAirspaces?: Array<ConfiguredAirspace>;

    selectedPeriodByTv?: Map<string, Array<TimePeriod>>;
    onSelectedPeriodByTvChange?: (selectedPeriodByTv: Map<string, Array<TimePeriod>>) => void;

    countType: CountType;
    onCountTypeChanged?(countType: CountType): void;
}

interface FmpNetworkMonitoringState extends NetworkMonitoringState {}

export class FmpNetworkMonitoring extends NetworkMonitoring<FmpNetworkMonitoringProps, FmpNetworkMonitoringState> {
    handleSelectAll = () => {
        this.props?.onSelectionChange(this.props?.monitoredTvs);
    };

    handleClearSelection = () => {
        this.props?.onSelectionChange([]);
    };

    render() {
        return (
            <Flex className="network-monitoring-panel" direction="vertical">
                <Flex size="3vw">
                    <Flex size="12vw" className="global-monitoring-panel" direction="vertical">
                        <Banner dataset={AppContext.getDataset()} />
                        {/*<Flex size="4em">*/}
                        {/*    <UserInfo userProfile={AppContext.configData?.userProfile} settings={this.props.settings} onSettingsUpdated={this.props.onSettingsUpdated}/>*/}
                        {/*</Flex>*/}
                    </Flex>
                    <NetworkMonitoringHeader
                        currentTime={this.props.currentTime}
                        monitoredPeriod={this.props.monitoredPeriod}
                        monitoredMcdmMeasures={this.props.monitoredMcdmMeasures}
                        coordinationSummaries={this.props.coordinationSummaries}
                        selectedTvs={this.props.selectedTvs}
                        tvSetMap={this.props.tvSetMap}
                        countType={this.props.countType}
                        onCountTypeChanged={this.props.onCountTypeChanged}
                        hideTextFilter={true}
                        onTextFilterChange={this.props.onTextFilterChange}
                        onSelectAll={this.handleSelectAll}
                        onClearSelection={this.handleClearSelection}
                        globalFilterEnabled={this.props.globalFilterEnabled}
                        onGlobalFilterEnabledChanged={this.props.onGlobalFilterEnabledChanged}
                    />
                </Flex>
                <Flex
                    direction="horizontal"
                    style={{ margin: '2em 5.5em 0 2em', overflowY: 'auto', paddingRight: '1em' }}>
                    <Flex
                        direction="vertical"
                        size="100%"
                        style={{
                            height: '99%' /* Trick to prevent scrollbar to appear when content is not overflowing */,
                        }}>
                        <Flex direction="vertical">
                            <SectorFlows
                                currentTime={this.props.currentTime}
                                monitoredPeriod={this.props.monitoredPeriod}
                                configuredAirspaces={this.props.configuredAirspaces}
                                monitoredTvs={this.props.monitoredTvs}
                                monitoredMeasures={this.props.monitoredMeasures}
                                monitoredMcdmMeasures={this.props.monitoredMcdmMeasures}
                                countType={this.props.countType}
                                tvsOccupancyPeriods={this.props.tvsOccupancyPeriods}
                                selectedPeriodByTv={this.props.selectedPeriodByTv}
                                onSelectedPeriodByTvChange={this.props.onSelectedPeriodByTvChange}
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        );
    }
}
